<!-- create/modify customer quotations -->
<template>
  <div>
    <Header />
    <SumView v-if="calcSummary.summary_formatted != undefined" />
    <LeftNav />
    <main id="page-wrap">
      <vue-snotify></vue-snotify>
      <ValidationObserver ref="form">
        <form v-on:submit.prevent="onSubmit">
          <b-container fluid>
            <MainLifeInfoWidget />
            <LifeCoveredWidget />
            <FamilyInfoWidget />
            <RidersWidgetHolder
              v-if="mainInfoData.rdbMainLifeFrequency != 'S'"
            />
            <QuoteGenButton ref="GenerateButton" />
          </b-container>
        </form>
      </ValidationObserver>
    </main>
    <Footer />
  </div>
</template>

<script>
import MainLifeInfoWidget from "@/components/quote_deergayu/MainLifeInfoWidget.vue";
import FamilyInfoWidget from "@/components/quote_deergayu/FamilyInfoWidget.vue";
import LifeCoveredWidget from "@/components/quote_deergayu/LifeCoveredWidget.vue";
import RidersWidgetHolder from "@/components/quote_deergayu/RidersWidgetHolder.vue";
import Header from "@/components/common/layout/AppHeader.vue";
import Footer from "@/components/common/layout/AppFooter.vue";
import SumView from "@/components/common/layout/AppSummaryViewDeergayu";
import QuoteGenButton from "@/components/quote_deergayu/QuoteGenButton.vue";
import LeftNav from "@/components/common/layout/AppLeftNav";

import { mapState, mapActions } from "vuex";
import { SnotifyPosition } from "vue-snotify";

export default {
  name: "EditQuote",
  components: {
    MainLifeInfoWidget,
    FamilyInfoWidget,
    LifeCoveredWidget,
    RidersWidgetHolder,
    Header,
    Footer,
    QuoteGenButton,
    LeftNav,
    SumView,
  },

  computed: {
    ...mapState("quote_deergayu", ["mainInfoData", "calcSummary", "flash"]),
    ...mapState("common_actions", ["shakingIconAction"])
  },
  methods: {
    ...mapActions("quote_deergayu", ["addChangedData"]),
    async onSubmit() {
      this.$refs.GenerateButton.disableButton();
      this.$refs.form
        .validate()
        .then((result) => {
          if (!result) {
            //alert("error");
            this.$refs.GenerateButton.enableButton();
            this.$snotify.error("There are items that require your attention", {
              timeout: 3000,
              showProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              position: SnotifyPosition.centerTop,
            });
            return;
          } else {
            //this.$loading(true);
            if (this.$route.params.ref_no) {
              (async () => {
                await this.addChangedData("update", this.$route.params.ref_no);
                if (this.flash.status && this.flash.type == "S") {
                  this.$snotify
                    .success("Quotation Successfully Updated", {
                      timeout: 3000,
                      showProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: false,
                      position: SnotifyPosition.centerTop,
                    })
                    .on("destroyed", () =>
                      this.$router.push({
                        name: "quote_list",
                      })
                    );
                  // Need to fix here - snotify and routing not working : await removed
                  //this.$router.push("/quote_list");
                } else {
                  this.$refs.GenerateButton.enableButton();
                  this.$snotify.error(this.flash.error, {
                    timeout: 3000,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    position: SnotifyPosition.centerTop,
                  });
                  this.$refs.GenerateButton.enableButton();
                }
              })();
            } else {
              (async () => {
                await this.addChangedData("create");
                if (this.flash.status && this.flash.type == "S") {
                  this.$snotify
                    .success("Quotation Successfully Created", {
                      timeout: 3000,
                      showProgressBar: true,
                      closeOnClick: true,
                      pauseOnHover: false,
                      position: SnotifyPosition.centerTop,
                    })
                    .on("destroyed", () =>
                      this.$router.push({
                        name: "quote_list",
                      })
                    );
                  // Need to fix here - snotify and routing not working : await removed
                  //this.$router.push("/quote_list");
                } else {
                  this.$snotify.error(this.flash.error, {
                    timeout: 3000,
                    showProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    position: SnotifyPosition.centerTop,
                  });
                  this.$refs.GenerateButton.enableButton();
                }
              })();
            }
            //this.$loading(false);
          }
          //alert("success");
        })
        .catch(() => {});
    },

    /* 
      Removed Reason : Removed since the summary panel is not working
      Removed by     : Menuka Walpitagamage
      Removed on     :[20190820]
    
    ...mapActions("quotation", ["addChangedData"]),
    onSubmit() {
      this.$validator.validateAll();

      if (!this.errors.any()) {
        if (this.$route.params.ref_no) {
          this.addChangedData("update", this.$route.params.ref_no);
        } else {
          this.addChangedData("create");
        }
      } else {
        this.$snotify.error("There are items that require your attention", {
            timeout: 3000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            position: SnotifyPosition.rightTop
          });
      }
    }
    */
  },
  mounted(){
    this.shakingIconAction.product = 'deergayu';
  }
};
</script>

<style scoped>
div.card .card-header {
  background: #0560dd !important; /* fallback for old browsers */
  box-shadow: 0 10px 10px -12px rgba(0, 0, 0, 0.42),
    0 4px 10px 0px rgba(0, 0, 0, 0.12), 0 5px 7px -5px rgba(0, 0, 0, 0.2);
}
</style>
